import React,{useContext} from "react";
import { exportToPDF } from "./exportUtils"; // Assuming exportToPDF function is defined in a separate file
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import axios from "axios";

const ExportPdfButton = ({ formData }) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const handleExportPDF = async () => {
    try{

    exportToPDF(
      formData,
      `${formData.firstName} ${formData.lastName}_RegistrationForm.pdf`
    );

    if (localStorage.token) {
      setAuthToken(localStorage.token);
      }
    const response = await axios.post(`${appUrl}/api/dataexport`, {
      user_name: user?.name,
      azure_id: user?.azureID,
      fileName:  `${formData.firstName} ${formData.lastName}_RegistrationForm.pdf`,
      recordCount: 1,
      screen:"Primary Enrollments Admin Screen",
      exportType: "pdf", 
      exportStatus: "success" 
    });

  } catch (error) {
    console.error("Error during export:", error);
  }

  };

  return (
    <button className={`btn btn-llac-dark-green`} onClick={handleExportPDF}>
      Export to PDF
    </button>
  );
};

export default ExportPdfButton;
